import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'cm-body',
  templateUrl: './body.component.html',
  styleUrls: ['./body.component.scss'],
})
export class BodyComponent {}
